import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'squareCourses',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
  activeItem: {},
};

export const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    courseStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};
      state.buttonDesign = buttonDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        view: blockDesign.layout ?? 'squareCourses',
      };
    },
    courseClear: () => initialState,

    courseUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    courseUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    courseUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    courseUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    courseUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const { courseStore, courseClear, courseUpdateIsLoading, courseUpdateIsActive, courseUpdateBlockContent, courseUpdateBlockDesign, courseUpdateActiveItem } =
  courseSlice.actions;

export const selectCourseIsLoading = (state) => state.course.isLoading;

export const selectCourseId = (state) => state.course.id;
export const selectCourseUID = (state) => state.course.uid;
export const selectCourseSID = (state) => state.course.sid;

export const selectCourseBlockContent = (state) => state.course.blockContent;
export const selectCourseBlockDesign = (state) => state.course.blockDesign;
export const selectCourseSortItems = createSelector([selectCourseBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectCourseModules = createSelector([selectCourseBlockContent], ({ items }) => {
  return items?.map(({ id, modules }) => ({ id, modules }));
});

export const selectCourseItemDesign = (state) => state.course.itemDesign;
export const selectCourseButtonDesign = (state) => state.course.buttonDesign;
export const selectCourseContainerDesign = (state) => state.course.containerDesign;

export const selectCourseActiveItem = (state) => state.course.activeItem;

export default courseSlice.reducer;
